/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { DiscountDuration$inboundSchema, DiscountDuration$outboundSchema, } from "./discountduration.js";
import { DiscountProduct$inboundSchema, DiscountProduct$outboundSchema, } from "./discountproduct.js";
import { DiscountType$inboundSchema, DiscountType$outboundSchema, } from "./discounttype.js";
/** @internal */
export const DiscountFixedRepeatDurationMetadata$inboundSchema = z.union([z.string(), z.number().int(), z.boolean()]);
/** @internal */
export const DiscountFixedRepeatDurationMetadata$outboundSchema = z.union([z.string(), z.number().int(), z.boolean()]);
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var DiscountFixedRepeatDurationMetadata$;
(function (DiscountFixedRepeatDurationMetadata$) {
    /** @deprecated use `DiscountFixedRepeatDurationMetadata$inboundSchema` instead. */
    DiscountFixedRepeatDurationMetadata$.inboundSchema = DiscountFixedRepeatDurationMetadata$inboundSchema;
    /** @deprecated use `DiscountFixedRepeatDurationMetadata$outboundSchema` instead. */
    DiscountFixedRepeatDurationMetadata$.outboundSchema = DiscountFixedRepeatDurationMetadata$outboundSchema;
})(DiscountFixedRepeatDurationMetadata$ || (DiscountFixedRepeatDurationMetadata$ = {}));
export function discountFixedRepeatDurationMetadataToJSON(discountFixedRepeatDurationMetadata) {
    return JSON.stringify(DiscountFixedRepeatDurationMetadata$outboundSchema.parse(discountFixedRepeatDurationMetadata));
}
export function discountFixedRepeatDurationMetadataFromJSON(jsonString) {
    return safeParse(jsonString, (x) => DiscountFixedRepeatDurationMetadata$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'DiscountFixedRepeatDurationMetadata' from JSON`);
}
/** @internal */
export const DiscountFixedRepeatDuration$inboundSchema = z.object({
    duration: DiscountDuration$inboundSchema,
    duration_in_months: z.number().int(),
    type: DiscountType$inboundSchema,
    amount: z.number().int(),
    currency: z.string(),
    created_at: z.string().datetime({ offset: true }).transform(v => new Date(v)),
    modified_at: z.nullable(z.string().datetime({ offset: true }).transform(v => new Date(v))),
    id: z.string(),
    metadata: z.record(z.union([z.string(), z.number().int(), z.boolean()])),
    name: z.string(),
    code: z.nullable(z.string()),
    starts_at: z.nullable(z.string().datetime({ offset: true }).transform(v => new Date(v))),
    ends_at: z.nullable(z.string().datetime({ offset: true }).transform(v => new Date(v))),
    max_redemptions: z.nullable(z.number().int()),
    redemptions_count: z.number().int(),
    organization_id: z.string(),
    products: z.array(DiscountProduct$inboundSchema),
}).transform((v) => {
    return remap$(v, {
        "duration_in_months": "durationInMonths",
        "created_at": "createdAt",
        "modified_at": "modifiedAt",
        "starts_at": "startsAt",
        "ends_at": "endsAt",
        "max_redemptions": "maxRedemptions",
        "redemptions_count": "redemptionsCount",
        "organization_id": "organizationId",
    });
});
/** @internal */
export const DiscountFixedRepeatDuration$outboundSchema = z.object({
    duration: DiscountDuration$outboundSchema,
    durationInMonths: z.number().int(),
    type: DiscountType$outboundSchema,
    amount: z.number().int(),
    currency: z.string(),
    createdAt: z.date().transform(v => v.toISOString()),
    modifiedAt: z.nullable(z.date().transform(v => v.toISOString())),
    id: z.string(),
    metadata: z.record(z.union([z.string(), z.number().int(), z.boolean()])),
    name: z.string(),
    code: z.nullable(z.string()),
    startsAt: z.nullable(z.date().transform(v => v.toISOString())),
    endsAt: z.nullable(z.date().transform(v => v.toISOString())),
    maxRedemptions: z.nullable(z.number().int()),
    redemptionsCount: z.number().int(),
    organizationId: z.string(),
    products: z.array(DiscountProduct$outboundSchema),
}).transform((v) => {
    return remap$(v, {
        durationInMonths: "duration_in_months",
        createdAt: "created_at",
        modifiedAt: "modified_at",
        startsAt: "starts_at",
        endsAt: "ends_at",
        maxRedemptions: "max_redemptions",
        redemptionsCount: "redemptions_count",
        organizationId: "organization_id",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var DiscountFixedRepeatDuration$;
(function (DiscountFixedRepeatDuration$) {
    /** @deprecated use `DiscountFixedRepeatDuration$inboundSchema` instead. */
    DiscountFixedRepeatDuration$.inboundSchema = DiscountFixedRepeatDuration$inboundSchema;
    /** @deprecated use `DiscountFixedRepeatDuration$outboundSchema` instead. */
    DiscountFixedRepeatDuration$.outboundSchema = DiscountFixedRepeatDuration$outboundSchema;
})(DiscountFixedRepeatDuration$ || (DiscountFixedRepeatDuration$ = {}));
export function discountFixedRepeatDurationToJSON(discountFixedRepeatDuration) {
    return JSON.stringify(DiscountFixedRepeatDuration$outboundSchema.parse(discountFixedRepeatDuration));
}
export function discountFixedRepeatDurationFromJSON(jsonString) {
    return safeParse(jsonString, (x) => DiscountFixedRepeatDuration$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'DiscountFixedRepeatDuration' from JSON`);
}
//# sourceMappingURL=discountfixedrepeatduration.js.map